import Button from '@mui/material/Button'
import { FeatherIcon } from 'components/Icons'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './CardComposeButton.pcss'

interface CardComposeButtonProps {
  label?: React.ReactNode
  icon?: React.ReactNode
  className?: string
  disabled?: boolean
  // EXPL: The positioned wrapper, not the button. Cards that have to clear their footer write the
  // measured offset straight onto it instead of re-rendering to pass a `style`.
  wrapRef?: React.Ref<HTMLSpanElement>
  onClick: (e: React.MouseEvent) => void
}

// EXPL: Primary "Create post" button shown at the bottom of content/file cards on hover
export const CardComposeButton = React.forwardRef<HTMLButtonElement, CardComposeButtonProps>(
  function CardComposeButton({ label, icon, className, disabled, wrapRef, onClick }, ref) {
    const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation()
      onClick(e)
    }

    return (
      <span ref={wrapRef} className={`${styles.wrap} ${className || ''}`}>
        <Button
          ref={ref}
          variant="contained"
          color="primary"
          size="small"
          fullWidth
          disabled={disabled}
          startIcon={icon || <FeatherIcon className={styles.icon} />}
          className={styles.button}
          onClick={handleClick}
          data-testid="btn-create-post"
        >
          {label || <FormattedMessage id="content-card.actions.create-post" />}
        </Button>
      </span>
    )
  }
)

export default CardComposeButton
